module.exports = __webpack_public_path__ + "static/media/camera.2b651590.svg";